import React, { forwardRef, useEffect, useMemo } from 'react'
import { isEmpty } from 'lodash-es'
import { useDittoForm } from '@ow/ditto-core'
import { dealDefaultFieldData } from '@ow/utils'
import TabLayout from './tabLayout'
import GroupLayout from './groupLayout'
import { ditto } from '../../../ditto/register.field'

// 需要优化(参数等)
// editableSlugs = [{ slug, opts: {} }], 改为
const BasicWithLayout = function (
  {
    fields = [],
    data,
    isReCreate,
    originalData,
    editableSlugs = [], // 所有可编辑的，新建也应该提前处理好,目前字段重复，考虑去掉
    editableSlugFields = [], // 格式为[{ slug, opts: {新的} }...]
    defaultSlugsValues = {}, // 某些slug对应的默认值
    refTypeFilterMap = {}, // 关联表数据对应的默认筛选
    layouts = {},
    hiddenNavMenu = false,
    widgets,
    detailData,
    forbidRefresh,
    isHiddenMedia,
    waterMarkDefs,
    children,
  },
  ref
) {
  const showEditableSlugs =
    editableSlugs || (editableSlugFields || []).map((v) => v.slug)

  const finalEditbelFields = useMemo(() => {
    if (editableSlugFields.length) {
      return editableSlugFields.map((v) => {
        if (v.opts && refTypeFilterMap[v.opts.slug]) {
          return {
            ...v.opts,
            hiddenWhenCreate: isReCreate ? v.opts.hiddenWhenCreate : false,
            hidden: isReCreate ? v.opts.hidden : false,
            filters: refTypeFilterMap[v.opts.slug],
          }
        }
        if (isReCreate) {
          return v.opts
        }
        return { ...v.opts, hiddenWhenCreate: false, hidden: false }
      })
    }
    return fields.reduce((total, cur) => {
      if (showEditableSlugs.includes(cur.slug)) {
        if (refTypeFilterMap[cur.slug]) {
          total.push({
            ...cur,
            hiddenWhenCreate: isReCreate ? cur.hiddenWhenCreate : false,
            filters: refTypeFilterMap[cur.slug],
          })
        } else if (isReCreate) {
          total.push(cur)
        } else {
          const elem = { ...cur, hiddenWhenCreate: false }
          total.push(elem)
        }
      }
      return total
    }, [])
  }, [editableSlugs, editableSlugFields, isReCreate])

  const {
    control,
    reset,
    // errors,
    formControl,
    unregister,
    formState,
    editableFields,
    refConditonFields,
  } = useDittoForm(
    {
      fields: finalEditbelFields,
      allFields: fields,
      data: {
        ...originalData,
        ...defaultSlugsValues,
      },
      ditto,
    },
    ref
  )

  const props = {
    data,
    layout: layouts.children,
    fields,
    editableFields,
    refTypeFilterMap,
    formControl: { ...formControl, control, unregister, formState },
    isShowNavMenu: hiddenNavMenu ? false : !isEmpty(layouts),
    widgets,
    detailData,
    isHiddenMedia,
    refConditonFields,
    waterMarkDefs,
    children,
  }

  useEffect(() => {
    if (originalData && !forbidRefresh) {
      const obj = dealDefaultFieldData(fields, originalData || {})
      reset({
        ...obj,
        ...defaultSlugsValues,
        objectId: originalData.objectId,
      })
    }
  }, [originalData, editableSlugs])

  if (layouts.type === 'tabs') {
    return <TabLayout {...props} />
  }
  return <GroupLayout {...props} />
}

export default forwardRef(BasicWithLayout)
